import React, { Component } from 'react';
import { ValidationModal } from '../components/index';
import '../css/validations.css'

// import $ from 'jquery';

// const AMOUNT_FORMAT = /^\d{1,6}$/;
// const DESCRIPTION_FORMAT = /^[a-zA-ZÀ-ÿ\s]{4,50}$/;

class CashOutModal extends Component {
    // constructor(props) {
    //     super(props);
    //     this.state = {
    //         amountO: '', 
    //         descriptionO: ''
    //     };
    //     this.ChangeValue = this.ChangeValue.bind(this);
    //     this.ChangeDescription = this.ChangeDescription.bind(this);
    //   }


    //   ChangeValue(event) {
    //     this.setState({amountO: event.target.value});
    // }

    // ChangeDescription(event) {
    //     this.setState({descriptionO: event.target.value});
    // }

    // ValidateAmount = async () => {
    //     let element= document.getElementById('amountO');
    //     let text= document.querySelector(`#grupo__amountO .form__input-error`);
    //     let require= document.querySelector(`#grupo__amountO .form__input-void`);

    //     if (!this.state.amountO== ''){   

    //         if (!AMOUNT_FORMAT.test(this.state.amountO)){

    //             element.classList.add('form__group-incorrect');
    //             element.classList.remove("form__group-correct");
    //             text.classList.add('form__input-error-active');
    //             require.classList.remove('form__input-void-active');
    //         }else{
    //             element.classList.remove('form__group-incorrect');
    //             element.classList.add("form__group-correct");
    //             text.classList.remove('form__input-error-active');
    //             require.classList.remove('form__input-void-active');
    //         }
    //     }else{
    //         element.classList.add('form__group-incorrect');
    //         element.classList.remove("form__group-correct");
    //         require.classList.add('form__input-void-active');
    //         text.classList.remove('form__input-error-active');
    //     }
    // }

    // ValidateDescription = async () => {
    //     let element= document.getElementById('descriptionO');
    //     let require= document.querySelector(`#grupo__amountO .form__input-void`);
    //     if (!this.state.descriptionO == ''){   
    //         if (!DESCRIPTION_FORMAT.test(this.state.descriptionO)){
    //             element.classList.add('form__group-incorrect');
    //             element.classList.remove("form__group-correct");
    //             require.classList.remove('form__input-void-active');
    //         }else{
    //             element.classList.remove('form__group-incorrect');
    //             element.classList.add("form__group-correct");
    //             require.classList.remove('form__input-void-active');}
    //     }else{
    //         element.classList.add('form__group-incorrect');
    //         element.classList.remove("form__group-correct");
    //         require.classList.add('form__input-void-active');
    //     }
    // }

    // ValidateAll = async () => {
    //     this.ValidateAmount();
    //     this.ValidateDescription();
    // }

    // ValidateCashOut = async () => {
    //     this.ValidateAll();
    //     if (!this.state.amountO || 
    //         !this.state.descriptionO ||
    //         this.state.amountO<1
    //         ) {
    //         return;
    //     }
    //     $('#cashOutModal').modal('hide');
    //     $('#vmCashOutModal').modal('show');
    // }

    // ResetValidations = async () => {
    //     const ids=[ 
    //         'amountO',
    //         'descriptionO',
    //     ];
    //     for (let index = 0; index < ids.length; index++) {
    //         let element= document.getElementById(ids[index]);
    //         let text= document.querySelector(`#grupo__`+ids[index]+` .form__input-error`);
    //         let require= document.querySelector(`#grupo__`+ids[index]+` .form__input-void`);
    //         element.classList.remove("form__group-correct");
    //         element.classList.remove('form__group-incorrect');
    //         if (ids[index]!== 'descriptionO') {
    //             text.classList.remove('form__input-error-active');
    //             require.classList.remove('form__input-void-active');
    //         }

    //     } 
    // }

    // ResetModal = async ()=>{
    //     await this.ResetValidations();
    //     this.setState({amountO: []});
    //     this.setState({descriptionO: []});
    // }

    // MakeCashOut= async ()=>{
    //     const {cashOut, ShowRefMoveCashModal} = this.props;
    //     let data={
    //         amount:this.state.amountO, 
    //         descrip:this.state.descriptionO,
    //         type:"out"
    //     }
    //     localStorage.setItem('lastCashMove', JSON.stringify(data));
    //     cashOut(this.state.amountO, this.state.descriptionO);
    //     ShowRefMoveCashModal();
    //     this.ResetModal();
    // }

    render() {
        const { cashMovementModel, ChangeAmount, ChangeComment, ShowCashOutModal, SendCashMovement} = this.props
        return (
            <div>
                <div className="modal fade" id="cashOutModal" data-backdrop="static" data-keyboard="false" tabIndex="-1" aria-labelledby="cashOutModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content" style={{ boxShadow: "1px 1px 10px rgba(1,1,1,0.3)" }}>
                            <div className="modal-body" id="grupo__amountO">
                                <h4>Retiro de efectivo</h4>
                                <table>
                                    <thead>
                                        <tr>
                                            <td>
                                                <h5 className="form-label pl-5">Efectivo: </h5>
                                            </td>
                                            <td>
                                                <div className="input-group pl-5 pr-5 pb-3 pt-3"  >

                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text" id="basic-addon1" style={{ backgroundColor: "#dc3545", borderColor: "#dc3545", color: "#fff" }}><strong>$</strong></span>
                                                    </div>
                                                    <input
                                                        id="amountO"
                                                        type="number"
                                                        className="form-control form__input"
                                                        placeholder="0.00"
                                                        min="0"
                                                        pattern="^[0-9]+"
                                                        value={cashMovementModel ? cashMovementModel.cashAmount : ''}
                                                        onChange={(event) => ChangeAmount(event.target.value)}
                                                    />
                                                </div>
                                            </td>
                                        </tr>
                                    </thead>
                                </table>
                                <div id="grupo__descriptionO">
                                    <div className="input-group pl-5 pr-5">
                                        <textarea
                                            id="descriptionO"
                                            className="form-control form__input"
                                            aria-label="With textarea"
                                            placeholder="Descripción"
                                            value={cashMovementModel ? cashMovementModel.comment : ''}
                                            onChange={(event) => ChangeComment(event.target.value)}
                                        />
                                    </div>
                                </div>
                                <p className="form__input-error ml-5">Solo números de max. 6 digitos.</p>
                                <p className="form__input-void ml-5">Ningun campo puede ir vacio.</p>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => ShowCashOutModal(false)}>Cancelar</button>
                                <button type="button" className="btn btn-danger" onClick={() => SendCashMovement(2)}><i className="fa fa-minus-circle mr-2" aria-hidden="true" />Retirar</button>
                            </div>
                        </div>
                    </div>
                </div>

                <ValidationModal
                    idValidation="vmCashOutModal"
                    message={"¿Seguro que quiere continuar?"}
                    idModalOrigin="#cashOutModal"
                    idModalDestiny="#refMoveCashModal"
                    eventOnclick={this.MakeCashOut}
                />
            </div>
        );
    }
}

export default CashOutModal;